import API from '@sparefoot/react-core/symbols/api';

// ------------------------------------
// Constants
// ------------------------------------
export const SAVE_BATCH_META_REQUEST = 'SFDC/USER/SAVE_BATCH_META_REQUEST';
export const SAVE_BATCH_META_SUCCESS = 'SFDC/USER/SAVE_BATCH_META_SUCCESS';
export const SAVE_BATCH_META_FAILURE = 'SFDC/USER/SAVE_BATCH_META_FAILURE';

// ------------------------------------
// Initial State
// ------------------------------------

export const initialState = {
	siteId: 27,
	visitId: null,
	user_ip: null,
	// Forwarded to the gateway as 'client-user-agent' for Optimizely bot filtering.
	userAgent: null,
	traffic_source_id: null,
	cid: null,
	ctid: null,
	gcid: null,
	geolocation: {
		city: 'Austin',
		country: 'US',
		region: 'TX',
		latitude: '30.2672',
		longitude: '-97.7431',
	},
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducer(state = initialState, action = {}) {
	if (action.type === SAVE_BATCH_META_SUCCESS) {
		return {
			...state,
			...(action.meta?.gcid && { gcid: action.meta.gcid }),
		};
	}
	return state;
}

/**
 * Save multiple meta entries in a single request
 * @param {Array<{key: string, value: string}>} entries - Array of meta entries
 * @param {Object} meta - Redux action meta (gcid/gclid values for state update)
 */
export function saveBatchMeta(entries, meta = {}) {
	return {
		[API]: {
			method: 'POST',
			types: [
				SAVE_BATCH_META_REQUEST,
				SAVE_BATCH_META_SUCCESS,
				SAVE_BATCH_META_FAILURE,
			],
			endpoint: '/api/visit/meta',
			meta,
			data: {
				meta: entries,
			},
		},
	};
}
